import request from '@/utils/request'

export default {

  //修改收货地址
  userAddress: (data) => {
    return request({
      url: 'api/User/address',
      method: 'post',
      data
    })
  }, //退出登录
  userLogout: (data) => {
    return request({
      url: 'api/Login/logout',
      method: 'get',
      data
    })
  },

}




// WEBPACK FOOTER //
// ./src/api/user.js